import { Auth } from '@nackle/bridge';
import { idURL } from 'endpoints';

const auth = new Auth( {
    authority: idURL
} );

export default auth;

export function hasPermission( permission ) {
    const userPermissions = auth?.state?.claims?.permissions;

    if ( !userPermissions ) {
        return false;
    }

    const [ app, key ] = permission.split( '.', 2 );

    const appPermissions = userPermissions[ app ];

    if ( !Array.isArray( appPermissions ) ) {
        return false;
    }

    return appPermissions.includes( key );
}
